
      import API from "!../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../node_modules/style-loader/dist/runtime/singletonStyleDomAPI.js";
      
      import setAttributes from "!../../../../node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../node_modules/style-loader/dist/runtime/insertStyleElement.js";
      
      import content, * as namedExport from "!!../../../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-27.use[1]!../../../../node_modules/vue-loader/dist/stylePostLoader.js!../../../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-27.use[2]!../../../../node_modules/resolve-url-loader/index.js??clonedRuleSet-27.use[3]!../../../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-27.use[4]!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SwisstopoSearch.vue?vue&type=style&index=0&id=412d46e9&lang=scss";
      
      

var options = {};

;
options.setAttributes = setAttributes;
options.insert = function (element) {
            window.SI_GATEWAY_CSS = element;
        };
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-27.use[1]!../../../../node_modules/vue-loader/dist/stylePostLoader.js!../../../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-27.use[2]!../../../../node_modules/resolve-url-loader/index.js??clonedRuleSet-27.use[3]!../../../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-27.use[4]!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SwisstopoSearch.vue?vue&type=style&index=0&id=412d46e9&lang=scss";
       export default content && content.locals ? content.locals : undefined;
